import { render, staticRenderFns } from "./listClients.vue?vue&type=template&id=53b5aadb&scoped=true"
import script from "./listClients.vue?vue&type=script&lang=js"
export * from "./listClients.vue?vue&type=script&lang=js"
import style0 from "./listClients.vue?vue&type=style&index=0&id=53b5aadb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5aadb",
  null
  
)

export default component.exports